$(() => {
    // проверяем и устанавливаем классы в зависимости от параметров
    function cardToggleClass(val) {
        // если раскладка grid
        if (val === "grid") {
            // Убираем класс с кнопки и добавляем на активную
            $(".js-card-size").removeClass("active");
            $(".card-size__btn--grid").addClass("active");
            // убираем старый класс раскладки карточке и добавляем новый
            // задержка для плавности и fix от глюков при большом количестве карточек
            setTimeout(() => {
                $("body")
                    .removeClass("card-list card-table")
                    .addClass("card-grid");
            }, 150);
            // если раскладка list
        } else if (val === "list") {
            // Убираем класс с кнопки и добавляем на активную
            $(".js-card-size").removeClass("active");
            $(".card-size__btn--list").addClass("active");
            // убираем старый класс раскладки карточке и добавляем новый
            // задержка для плавности и fix от глюков при большом количестве карточек
            setTimeout(() => {
                $("body")
                    .removeClass("card-grid card-table")
                    .addClass("card-list");
            }, 150);
            // если раскладка table
        } else if (val === "table") {
            // Убираем класс с кнопки и добавляем на активную
            $(".js-card-size").removeClass("active");
            $(".card-size__btn--table").addClass("active");
            // убираем старый класс раскладки карточке и добавляем новый
            // задержка для плавности и fix от глюков при большом количестве карточек
            setTimeout(() => {
                $("body")
                    .removeClass("card-grid card-list")
                    .addClass("card-table");
            }, 150);
        }
    }

    // изменения размера карточек при клике на табы
    $("body").on("click", ".js-card-size", function() {
        let cardBtnSize = $(this).data("size");
        // меняем класс карточек в зависимости от активного таба
        cardToggleClass(cardBtnSize);
        // записываем в куки на 30 дней
        $.cookie("cardSize", cardBtnSize, {
            expires: 30,
            path: "/"
        });
    });
    // меняем класс карточек и табов в зависимости установленного значения в куки
    cardToggleClass($.cookie("cardSize"));
});



// WEBPACK FOOTER //
// ./markup/components/card/card.js